import { AnimatePresence, motion } from 'framer-motion';
import { AiOutlineLoading } from 'react-icons/ai';
import styled from 'styled-components';

const Container = styled(motion.div)`
    position: absolute;
    inset: 0;
    background-color: white;
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 11;

    .spinner {
        display: flex;
    }

    svg {
        width: 8rem;
        height: 8rem;
        color: #ffde0d;
    }
`;

export const BasicLoading = ({ isLoading }: { isLoading: boolean }) => {
    return (
        <AnimatePresence>
            {isLoading && (
                <Container
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <motion.div
                        className="spinner"
                        animate={{ rotate: [0, 360] }}
                        transition={{
                            repeat: Infinity,
                            ease: 'linear',
                            duration: 0.5,
                        }}
                    >
                        <AiOutlineLoading />
                    </motion.div>
                </Container>
            )}
        </AnimatePresence>
    );
};
